import { createSlice } from "@reduxjs/toolkit";
import { creatSetState, mapBaseReducers } from "@/utils/reduxUtils";
import { ScheduleType } from "@/containers/preview-export/types";
import { History } from "../services/adjustSchedule";
import {
  ClassScheduleDetailVO,
  IFetchConflictfromArranged,
} from "@/services/courseScheduling/adjustSchedule";

interface IWatingCourseList {
  combinationList: ClassScheduleDetailVO[];
  courseClassMOList: ClassScheduleDetailVO[];
  hebanList: ClassScheduleDetailVO[];
}

export interface AdjustScheduleState {
  // 类型 'AdminClass' === '班级', 'Teacher' === '教师';
  scheduleType: ScheduleType;
  // 当前班级id
  currAdminClassId: string;
  // 当前教师ID
  currAdjustTeacherId: string;
  // 当前教师选中的完整key（包含年级和科目信息）
  currTeacherSelectedKey: string;
  isEngineReady: boolean;
  // 课表格子第二次点击 x y
  subActive: Record<string, number>;
  // 课表格子第一次点击 x y
  mainActive: Record<string, number>;
  // 课表暂存区数据
  watingCourseList: ClassScheduleDetailVO[];
  pHistoryList: History[];
  rHistoryList: History[];
  // 格子冲突数据
  conflictsInfoArr: IFetchConflictfromArranged[];
  // 暂存区选中id
  sameCellId: string;
  currGrade: string; // 班级课表下所选择的年级
  gradeCourseId: string[]; // 教师课表下所用到的年级、课程id
  dropType: "courseInside" | "courseOutside";
  predictApiLoading: { key: string; value: boolean }[]; // 改为对象数组
  shouldReSchedule: boolean; // 是否需要重新排课
  temporaryAreaIsExpanded?: boolean; // 暂放区 是否展开
  previewTableTargetXY: Record<string, number>; // 拖动时 预览导出对应的x和y
}

// TODO: 策略模式
const initialState: AdjustScheduleState = {
  scheduleType: "AdminClass",
  currAdminClassId: "",
  currAdjustTeacherId: "",
  currTeacherSelectedKey: "",
  isEngineReady: false,
  subActive: { x: 0, y: 0 },
  mainActive: { x: 0, y: 0 },
  watingCourseList: [],
  pHistoryList: [],
  rHistoryList: [],
  conflictsInfoArr: [],
  sameCellId: "",
  gradeCourseId: [],
  currGrade: "",
  dropType: "courseInside",
  predictApiLoading: [],
  shouldReSchedule: false,
  temporaryAreaIsExpanded: false,
  previewTableTargetXY: { x: 0, y: 0 },
};

const adjustScheduleSlice = createSlice({
  name: "adjustSchedule",
  initialState: initialState,
  reducers: {
    ...mapBaseReducers(),
    // 设置 predictApiLoading
    setPredictApiLoading: (state, action) => {
      const { key, value } = action.payload;

      // 检查是否已经存在相同的 key
      const existingIndex = state.predictApiLoading.findIndex((item) => item.key === key);

      if (existingIndex !== -1) {
        // 如果存在相同的 key，更新其 value
        state.predictApiLoading[existingIndex].value = value;
      } else {
        // 如果不存在相同的 key，添加新的项
        state.predictApiLoading.push({ key, value });

        // 保持数组长度不超过 3
        if (state.predictApiLoading.length > 3) {
          state.predictApiLoading.shift(); // 删除最早添加的项
        }
      }
    },
  },
});

export const { setPredictApiLoading } = adjustScheduleSlice.actions;
export const setAdjustScheduleState = creatSetState("adjustSchedule");

export default adjustScheduleSlice;
